import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const TogPackingList = lazy(() => import('./pages/TogPackingList'));
const TogPackingWorkflow = lazy(() => import('./pages/TogPackingWorkflow'));
const PackingProcess = lazy(() => import('./pages/PackingProcess'));

const togPackingRoutes: RouteObject[] = [
  {
    index: true,
    element: <TogPackingList />,
  },
  {
    path: 'create',
    element: <TogPackingWorkflow />,
  },
  {
    path: ':id/pack',
    element: <PackingProcess />,
  },
  {
    path: ':id',
    element: <PackingProcess />,
  },
];

export default togPackingRoutes;
